import { lisaConstants } from "reduxLib/constants";


const LisaReducer = (state = { lisaLoginError: "", chatData: [] }, action) => {

    switch (action.type) {
        case lisaConstants.SET_LOGIN_ERROR:
            return { ...state, lisaLoginError: "lisa_auth_failed" }

        case lisaConstants.REMOVE_LOGIN_ERROR:
            return { ...state, lisaLoginError: "" }
        case lisaConstants.UPDATE_CHAT_DATA:
            return { ...state, chatData: [...state.chatData, action.payload] }

        default:
            return state
    }
}

export default LisaReducer;